var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 13.951 7.476"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#b5b7b9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M13.244.708 6.976 6.976.708.708",
  "data-name": "Path 27101"
})));
export { SvgArrowDown as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow_down.730bc1e4150ad361e90c6c5b82c76fb0.svg";